import { EditModal } from "../../../shared/components/edit-table/edit-modal";
import { EditTable, EditTableSortColumn, IEditController } from "../../../shared/components/edit-table/edit-table";
import { TableRenderer, TableRenderType } from "../../../shared/components/edit-table/table-renderer";
import { CabMonthlySurvey } from "../../../shared/entities/cab-hub/cab-survey/cab-survey";
import { CabHubConnection } from "../../../shared/entities/cab-hub/connection/cab-hub-connection";
import { HubMonthlySurvey } from "../../../shared/entities/cab-hub/hub-survey/hub-survey";
import { JsonItem, PickListItem } from "../../../shared/entities/pick-list/pick-list.entities";
import { getDisplayDate, getMonthYearDisplay } from "../../../shared/scripts/date-functions";
import { CabHubActiveSurveyRow, CabHubCompletedSurveyRow, CabHubTrackingPageVm } from "./cab-hub-tracking.entities";
import { CabHubConnectionForm, CabSurveyForm, HubSurveyForm } from "./cab-hub-tracking.forms";
import { CompletedSurveyTable, CompletedSurveyTableType } from "./cab-hub-tracking.tables";
import { CompletedSurveyViewModal, CompletedSurveyViewType } from "./completed-survey.view";


export class AdminMemberView {
    viewModel: CabHubTrackingPageVm;
    activeSurveyTable: EditTable;

    addCabSurveyModal: EditModal;
    editCabSurveyModal: EditModal;
    addHubSurveyModal: EditModal;
    editHubSurveyModal: EditModal;

    completedSurveyTable: CompletedSurveyTable;
    completedSurveyView: CompletedSurveyViewModal;

    connectionTable: EditTable;
    addConnectionModal: EditModal;
    editConnectionModal: EditModal;

    tableRenderer: TableRenderer;

    constructor(viewModel: CabHubTrackingPageVm) {
        this.viewModel = viewModel;
        this.tableRenderer = new TableRenderer(viewModel.PickLists);
        this.activeSurveyTable = this.getActiveSurveyTable();
        this.completedSurveyTable = new CompletedSurveyTable(CompletedSurveyTableType.Admin);
        this.completedSurveyView = new CompletedSurveyViewModal("survey-view-modal", viewModel.PickLists);
        this.connectionTable = this.getConnectionTable();
    }

    initialize(): void {      
        this.initializeActiveSurveys();
        this.initializeCompletedSurveys();    
        this.initializeConnections();
    }

    private initializeActiveSurveys(): void {
        let tableTarget = $(`#active-survey-table-container`);
        let tableHtml = this.activeSurveyTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.activeSurveyTable.initialize(this.viewModel.ActiveSurveys, this.viewModel.PickLists);

        $(`#active-surveys-section`).on("shown.bs.collapse", () => {
            this.completedSurveyTable.resizeTable();
        })
    }

    private initializeCompletedSurveys(): void {
        this.addCabSurveyModal = new EditModal({
            isAdd: true,
            editModalId: "survey-edit-modal",
            formSections: CabSurveyForm.getFormSections(true),
            modalTitle: "Add New CAB Survey",
            saveFn: this.saveCabSurvey
        })

        this.editCabSurveyModal = new EditModal({
            isAdd: false,
            editModalId: "survey-edit-modal",
            formSections: CabSurveyForm.getFormSections(false, true),
            modalTitle: "Edit CAB Survey",
            saveFn: this.saveCabSurvey,
            displayPropertyFn: () => "Survey"
        });

        this.addHubSurveyModal = new EditModal({
            isAdd: true,
            editModalId: "survey-edit-modal",
            formSections: HubSurveyForm.getFormSections("the CAB Member", true),
            modalTitle: "Add New Hub Survey",
            saveFn: this.saveHubSurvey,
        });

        this.editHubSurveyModal = new EditModal({
            isAdd: false,
            editModalId: "survey-edit-modal",
            formSections: HubSurveyForm.getFormSections("the CAB Member", false, true),
            modalTitle: "Edit Hub Survey",
            saveFn: this.saveHubSurvey,
            displayPropertyFn: () => "Survey"
        });

        let tableTarget = $(`#completed-survey-table-container`);
        let tableHtml = this.completedSurveyTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.completedSurveyTable.initialize(this.viewModel.CompletedSurveys, this.viewModel.PickLists);

        $(`#completed-surveys-content`).on("shown.bs.collapse", () => {
            this.completedSurveyTable.resizeTable();
        })

        tableTarget.on("click", ".js-view-completed-survey", (e) => {
            let target = $(e.currentTarget);
            let targetId = <string>target.data("surveyId");
            let targetType = <string>target.data("surveyType")
            let foundSurvey = this.viewModel.CompletedSurveys.find(survey => survey.SurveyId.toString() == targetId && survey.SurveyType == targetType);
            if (foundSurvey) {
                let type = CompletedSurveyViewType.CAB;
                if (targetType?.toLowerCase() != "cab") {
                    type = CompletedSurveyViewType.Hub;
                }
                this.completedSurveyView.openModal(foundSurvey, type);
            }
        })

        tableTarget.on("click", ".dropdown-edit-survey-option", () => {
            let targetSurvey: CabHubCompletedSurveyRow = this.completedSurveyTable.table.currentTargetItem;
            if (targetSurvey.SurveyType == "CAB") {
                let editSurvey = CabMonthlySurvey.convertSurveyRowVm(targetSurvey);
                this.editCabSurveyModal.openModal([editSurvey], this.viewModel.PickLists);
            }
            else if (targetSurvey.SurveyType == "Hub") {
                let editSurvey = HubMonthlySurvey.convertSurveyRowVm(targetSurvey);
                this.editHubSurveyModal.openModal([editSurvey], this.viewModel.PickLists);
            }      
        })

        $(`#add-hub-survey-btn`).on("click", () => {
            this.addHubSurveyModal.openModal([HubMonthlySurvey.getDefault(0, 0, 0)], this.viewModel.PickLists);
        });

        $(`#add-cab-survey-btn`).on("click", () => {
            this.addCabSurveyModal.openModal([CabMonthlySurvey.getDefault(0, 0, 0)], this.viewModel.PickLists);
        });
    }

    private initializeConnections(): void {
        this.addConnectionModal = new EditModal({
            editModalId: "survey-edit-modal",
            formSections: CabHubConnectionForm.getFormSections(),
            modalTitle: "Add New Connection",
            saveFn: this.saveConnection,
        });

        this.editConnectionModal = new EditModal({
            isAdd: false,
            editModalId: "survey-edit-modal",
            formSections: CabHubConnectionForm.getEditFormSections(),
            modalTitle: "Edit Connection",
            saveFn: this.saveConnection,
            displayPropertyFn: this.getConnectionDisplay
        })

        let tableTarget = $(`#connection-table-container`);
        let tableHtml = this.connectionTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.connectionTable.initialize(this.viewModel.Connections, this.viewModel.PickLists);

        $(`#connections-content`).on("shown.bs.collapse", () => {
            this.completedSurveyTable.resizeTable();
        });

        tableTarget.on("click", ".dropdown-edit-connection-option", () => {
            let foundItem = this.connectionTable.currentTargetItem;
            if (foundItem) {
                this.editConnectionModal.openModal([foundItem], this.viewModel.PickLists);
            }
        })

        $(`.add-connection-btn`).on("click", () => {
            let newConnection = CabHubConnection.getDefault(0, 0);
            this.addConnectionModal.openModal([newConnection], this.viewModel.PickLists);
        })
    }

    private async saveConnection(items: any[], isAdd: boolean): Promise<string> {
        try {
            let saveEndpoint = "/api/cab-match/connection";
            await $.ajax(saveEndpoint, {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            });

            window.location.reload(); // refresh on save;
        }
        catch {
            return "An error has occurred while saving. Please refresh the page and try again."
        }

        return "";
    }

    private async saveCabSurvey(items: any[], isAdd: boolean): Promise<string> {
        try {
            // Validate that survey doesn't already exist
            let validateResult = await $.ajax("/api/cab-match/validate-cab-survey", {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            })
            if (!validateResult) {
                return "A survey already exists for the specified connection & reporting period."
            }

            let saveEndpoint = "/api/cab-match/cab-survey";
            await $.ajax(saveEndpoint, {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            });

            window.location.reload(); // refresh on save;
        }
        catch {
            return "An error has occurred while saving. Please refresh the page and try again."
        }

        return "";
    }

    private async saveHubSurvey(items: any[], isAdd: boolean): Promise<string> {
        try {
            // Validate that survey doesn't already exist
            let validateResult = await $.ajax("/api/cab-match/validate-hub-survey", {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            })
            if (!validateResult) {
                return "A survey already exists for the specified connection & reporting period."
            }

            let saveEndpoint = "/api/cab-match/hub-survey";
            await $.ajax(saveEndpoint, {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            });

            window.location.reload(); // refresh on save;
        }
        catch {
            return "An error has occurred while saving. Please refresh the page and try again."
        }

        return "";
    }

    private getConnectionDisplay(connection: CabHubConnection, pickLists: JsonItem[]): string {
        let returnText = "Connection";
        let hubList: PickListItem[] = pickLists.find(list => list.Id == "pl-short-hub")?.Json;
        let userList: PickListItem[] = pickLists.find(list => list.Id == "pl-user")?.Json;

        let foundHub = hubList.find(hub => hub.Id == connection.HubId);
        let foundUser = userList.find(user => user.Id == connection.CabMemberUserId);

        if (foundHub && foundUser) {
            returnText = `${foundUser.Value} | ${foundHub.Value}`;
        }
        return returnText;
    }

    private getActiveSurveyTable(): EditTable {
        let table = new EditTable({
            tableId: "active-survey-table",
            columns: [
                {
                    data: null, title: "Reporting Period", className: "text-left font-size12 nowrap",
                    render: (data: CabHubActiveSurveyRow, type: string): string => {
                        const display = getMonthYearDisplay(data.ReportingMonth, data.ReportingYear);
                        return type === "display" ? display : `${data.ReportingYear}-${data.ReportingMonth}`;
                    }
                },
                { data: "CabMemberName", title: "CAB Member", className: "text-left font-size12" },
                { data: "HubShortName", title: "Hub", className: "text-left font-size12 table-column-md" },
                {
                    data: "CabSurveySubmitted", title: "CAB Survey", className: "text-center font-size12 nowrap",
                    render: (submitted: boolean, type: string): string => {
                        if (type === "display") {
                            return `
                                <span class="${submitted == true ? "cab-edit-table-active-pill" : "cab-detail-table-inactive-pill"}">
                                    ${submitted == true ? "Complete" : "Awaiting"}
                                </span>
                            `;
                        }

                        return submitted ? "Complete" : "Awaiting";                  
                    }
                },
                {
                    data: "HubSurveySubmitted", title: "Hub Survey", className: "text-center font-size12 nowrap",
                    render: (submitted: boolean, type: string): string => {
                        if (type === "display") {
                            return `
                                <span class="${submitted == true ? "cab-edit-table-active-pill" : "cab-detail-table-inactive-pill"}">
                                    ${submitted == true ? "Complete" : "Awaiting"}
                                </span>
                            `;
                        }

                        return submitted ? "Complete" : "Awaiting";  
                    }
                },
            ],
            itemDisplayName: "Surveys",
            sortOrder: [new EditTableSortColumn(0, "desc")]
        });

        return table;
    }

    private getConnectionTable(): EditTable {
        let connectTable = new EditTable({
            tableId: "connection-table",
            columns: [
                { data: "CabMemberUserId", title: "CAB Member", className: "general text-left nowrap font-size12 table-column-md", render: (data: number): string => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-user"); } },
                { data: "HubId", title: "Hub", className: "general text-left font-size12 nowrap", render: (data: number): string => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-short-hub"); } },
                {
                    data: "StatusId", title: "Status", className: "general text-center font-size12 nowrap", render: (data: number, type: string): string => {
                        const display = this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-connection-status");
                        if (type !== "display") {
                            return display;
                        }
                        return `<span class="${data == 1 ? "cab-edit-table-active-pill" : "cab-detail-table-inactive-pill"}">${display}</span>`
                    }
                },
                { data: "StartDate", title: "Start Date", className: "general text-left font-size12 nowrap", render: (data: string, type: string): string => { return getDisplayDate(new Date(data)); } },
                { data: "EndDate", title: "End Date", className: "general text-left font-size12 nowrap", render: (data: string, type: string): string => { return getDisplayDate(new Date(data)); } },
                {
                    data: "LastModifiedDate", title: "Last Updated", className: "general text-left font-size12 nowrap",
                    render: (data: string, type: string): string => {
                        if (type === "display") {
                            return getDisplayDate(new Date(data));
                        }
                        return data;
                    }
                },
                {
                    data: "Id", title: "Connection", className: "general text-center font-size12 nowrap", orderable: false,
                    render: (data: number, type: string): string => {
                        if (type !== "display") { return `${data ?? ""}`; }
                        return `
                            <a class="btn btn-sm btn-primary detail-btn font-size11" href="/secure/cab-hub/connection-details/${data}">
                                View Details
                            </a>
                        `;
                    }
                },
                { data: "AdminNotes", title: "Check-in Notes", visible: false, className: "check-in-notes text-left font-size12 table-column-lg nowrap", render: (data: string): string => { return data?.trim() || ""; } },
                { data: "OneMonthCheckInNotes", title: "1-Month Notes", visible: false },
                { data: "SixMonthCheckInNotes", title: "6-Month Notes", visible: false }
            ],
            sortOrder: [new EditTableSortColumn(5, "desc")],
            itemDisplayName: "Connections",
            isEditable: true,
            editController: new CabHubConnectionController(),         
        });

        return connectTable;
    }
}
   

class CabHubConnectionController implements IEditController {
    constructor() { }

    public async saveItems() { return; }
    public getEditMenu(): string {
        return `
            <a class="dropdown-item dropdown-edit-connection-option">
                <i class="fa-solid fa-pen-to-square dropdown-icon pr-2"></i> Edit Connection
            </a>
        `;
    }
}